import apiClient from "../../utils/api.client";

const getAllOrders = async (page, pageSize, sort) => {
  // const { criteria, field } = sort;
  // return fetch(`${getServiceUrl()}/orders?pageNumber=${page}&pageSize=${pageSize}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'id'}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json()
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const { criteria, field } = sort;
    const url = `/delivery-service/orders?pageNumber=${page}&pageSize=${pageSize}&orderCriteria=${criteria || "DESC"}&orderField=${field || "id"}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllOrders EP: ", error);
    throw error;
  }
};

const getOrderById = async (id) => {
  try {
    const url = `/delivery-service/orders/${id}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getOrderByID EP: ", error);
    throw error;
  }
};

const createOrder = async (payload) => {
  // return fetch(`${getServiceUrl()}/orders`, {
  //   method: "POST",
  //   headers: { "Content-Type": "application/json" },
  //   body: JSON.stringify(payload)
  // }).then(res => {
  //   if (res.status === 200) {
  //     return res.json()
  //   } else {
  //     throw { res, isServiceException: true }
  //   }
  // })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const url = `/delivery-service/orders`;
    const response = await apiClient.post(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at createOrder EP: ", error);
    throw error;
  }
};

const deleteOrder = async (id) => {
  // return fetch(`${getServiceUrl()}/orders/${id}`, {
  //   method: "DELETE",
  //   headers: { "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 204) {
  //       return res;
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const url = `/delivery-service/orders/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteOrder EP: ", error);
    throw error;
  }
};

const editOrder = async (payload) => {
  // return fetch(`${getServiceUrl()}/orders`, {
  //   method: "PUT",
  //   headers: { "Content-Type": "application/json" },
  //   body: JSON.stringify(payload)
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json()
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const url = `/delivery-service/orders`;
    const response = await apiClient.put(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at editOrder EP: ", error);
    throw error;
  }
};

const searchOrder = async (page, pageSize, filters, sort) => {
  // const { criteria, field } = sort;
  // return fetch(`${getServiceUrl()}/orders/search?pageNumber=${page}&pageSize=${pageSize}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'id'}${filters.orderId !== 0 ? `&orderId=${filters.orderId}` : ''}${filters.supplierId !== 0 ? `&supplierId=${filters.supplierId}` : ''}${filters.gameId !== 0 ? `&gameId=${filters.gameId}` : ''}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json()
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const { criteria, field } = sort;
    const url = `/delivery-service/orders/search?pageNumber=${page}&pageSize=${pageSize}&orderCriteria=${criteria || "DESC"}&orderField=${field || "id"}${filters.orderId !== 0 ? `&orderId=${filters.orderId}` : ""}${filters.supplierId !== 0 ? `&supplierId=${filters.supplierId}` : ""}${filters.gameId !== 0 ? `&gameId=${filters.gameId}` : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at searchOrder EP: ", error);
    throw error;
  }
};

const ordersService = {
  getAllOrders,
  getOrderById,
  createOrder,
  deleteOrder,
  editOrder,
  searchOrder,
};

export default ordersService;
